import React, { ChangeEvent, FC, useCallback } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { FormNodeTermsAgreementModel } from '../../../../shared/kiosk';
import { RichMarkdownIt } from '../../RichMarkdownIt';
import { TermsLoader } from '../../TermsLoader';

interface FormNodeTermsAgreementProps extends FormNodeTermsAgreementModel {
  readonly checked: boolean;
  readonly setChecked: (checked: boolean) => void;
}

export const FormNodeTermsAgreement: FC<FormNodeTermsAgreementProps> = ({
  id,
  markdown,
  termsKey,
  checked,
  setChecked,
}) => {
  const inputId = `agreement-checkbox-${id}`;
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setChecked(e.target.checked);
    },
    [setChecked],
  );

  return (
    <div className="form-node form-node-terms-agreement" id={`agreement-${id}`}>
      <div className="terms-container">
        <TermsLoader name={termsKey} />
      </div>
      <FormGroup check className="mt-10">
        <Input checked={checked} id={inputId} onChange={onChange} required type="checkbox" />
        <Label check for={inputId}>
          <RichMarkdownIt source={markdown} />
        </Label>
      </FormGroup>
    </div>
  );
};
